import "./PartnersPage.css";
import { useState, useEffect } from "react";
import Layout from "src/components/Layout";
import { fetchPartnersLogos } from "src/network/fetchPartnersLogos";

const PartnersPage = () => {
  const [partnersItems, setPartnersItems] = useState<{ source: string }[]>([]);

  useEffect(() => {
    const getPartners = async () => {
      try {
        const partners = await fetchPartnersLogos();
        setPartnersItems(partners);
      } catch (error) {
        console.error("Failed to fetch partners:", error);
      }
    };

    getPartners();
  }, []);

  return (
    <Layout>
      <section className="partners-page">
        <div className="partners-container">
          <div className="partners-page-title">
            <h2 className="dotmedico2">dotmedica</h2>
            <h2 className="partners-sbed2">partners</h2>
          </div>
          <div className="partners-items2">
            {[...partnersItems].map((partner, index) => (
              <div
                key={`${partner?.source}-${index}`}
                className="partners-card"
              >
                <div className="partners-page-logo">
                  <img src={`${partner.source}` }alt={`Partner ${index}`} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default PartnersPage;
